import type { CSSProperties } from "react";

type MorrowButtonStyle = CSSProperties & {
    "--site-muted"?: string;
    "--site-text"?: string;
};

/**
 * Buttons are visual leaves, not containers for themed content. Keeping the
 * content-color variables emitted by `siteBuilderBlockStyle` on the button
 * can make a background such as `var(--site-text)` resolve to the button's
 * own foreground color, leaving both the surface and label the same color.
 */
export function morrowButtonLeafStyle(style: CSSProperties): CSSProperties {
    const {
        "--site-muted": _siteMuted,
        "--site-text": _siteText,
        ...buttonStyle
    } = style as MorrowButtonStyle;

    return buttonStyle;
}
